import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive  } from '@angular/router';
import { SharedDataService  } from '../../services/shared-data.service';
import { environment } from "../../../environments/environment";
import { CommonModule } from '@angular/common';

const { loginAzureUrl } = environment;

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {

  merchantName: string;
  merchantLogo: string;
  requiresRendition: boolean = false;

  constructor(
    private router: Router,
    private sharedDataService: SharedDataService
  ) {}

  public ngOnInit() {
    this.merchantName = localStorage.getItem('merchant_name');
    this.merchantLogo = localStorage.getItem('merchant_logo');
    const value = localStorage.getItem('requires_rendition');
    this.requiresRendition = value === 'true';
  }

  public onSingOut() {
    localStorage.removeItem('auth.access_token')
    window.location.href = loginAzureUrl;
  }
}
